import { NEW_PATH_DELIMITER } from '@picsio/db/src/constants';

/** Parent folder path for a grouped saved search (`→A→B→name` → `→A→B`). */
export function sourceGroupPathFromSearchPath(searchPath) {
  if (!searchPath) return null;
  const parent = searchPath.split(NEW_PATH_DELIMITER).slice(0, -1).join(NEW_PATH_DELIMITER);
  return parent || null;
}

/**
 * After a move, keep an empty source folder visible when nothing remains under it.
 */
export function mergePreservedEmptyGroupPlaceholder(all, preservedPlaceholder) {
  if (!preservedPlaceholder?._id || !preservedPlaceholder.path) return all;
  if (all.some((ss) => ss._id === preservedPlaceholder._id)) return all;
  return [...all, preservedPlaceholder];
}
